import type React from 'react';
import type { IconProps } from 'types/icon';
import { SvgIcon } from './svg-icon';

const InfoCircle: React.FC<IconProps> = (props) => (
  <SvgIcon {...props}>
    {(c) => (
      <>
        <circle cx="12" cy="12" r="9" stroke={c} strokeWidth="1.5" />
        <path d="M12 11v5" stroke={c} strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="12" cy="8" r="0.75" fill={c} stroke={c} strokeWidth="0.5" />
      </>
    )}
  </SvgIcon>
);

export default InfoCircle;
